import { createElement, ReactElement } from 'react'
import { useControlStore } from '@editorStores'

const SceneMarker = (): ReactElement | null => {
  const sceneMarkers = useControlStore(state => state.sceneElements)

  return (
    <>
      {sceneMarkers.map(sceneMarker =>
        createElement(sceneMarker.component, {
          key: sceneMarker.id,
          ...sceneMarker.properties,
        }),
      )}
    </>
  )
}

export default SceneMarker
